import { List, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";

import "./CheckBoxItemList.scss";

interface CheckBoxItemListProps {
  listCount: number;
}

const CheckBoxItemList = (
  props: React.PropsWithChildren<CheckBoxItemListProps>,
) => {
  const { t } = useTranslation();
  const { listCount, children } = props;

  const renderEmptyListItem = (
    <ListItem divider className="list-item-empty">
      <ListItemText primary={t("noItemsAdded")} />
    </ListItem>
  );

  return (
    <div className="editable-item-list">
      {listCount === 0 ? renderEmptyListItem : <List>{children}</List>}
    </div>
  );
};

export default CheckBoxItemList;
